// External libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Zocdoc dependencies
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';
import { CustomMetrics } from '@zocdoc/frontend-metrics';

// This package
import { DropdownHeader } from '../../dropdown';
import { AppointmentItem } from '../AppointmentItem';

export class AppointmentList extends Component {
    static propTypes = {
        appointments: PropTypes.array.isRequired,
        onUpcomingAppointmentClick: PropTypes.func,
    };

    render() {
        // filter out past appointments
        const upcomingAppointments = this.props.appointments.filter(
            appointment => new Date(appointment.time) > new Date()
        );

        if (upcomingAppointments.length === 0) {
            return null;
        }

        return (
            <div {...filterToValidAttributes(this.props)}>
                <DropdownHeader data-test="appointments-header">
                    {`Upcoming appointments`}
                </DropdownHeader>

                <div data-test="appointments-container">
                    {this.renderAppointments(upcomingAppointments)}
                </div>
            </div>
        );
    }

    renderAppointments(appointments) {
        const { onUpcomingAppointmentClick } = this.props;

        return (
            <CustomMetrics>
                {({ sendMetric }) =>
                    appointments.map((appointment, i) => (
                        <AppointmentItem
                            key={i}
                            appointment={appointment}
                            onUpcomingAppointmentClick={
                                onUpcomingAppointmentClick
                            }
                            sendMetric={sendMetric}
                        />
                    ))
                }
            </CustomMetrics>
        );
    }
}
